"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDynamicScript = exports.RemoteComponent = void 0;
var RemoteComponent_1 = require("./RemoteComponent");
Object.defineProperty(exports, "RemoteComponent", { enumerable: true, get: function () { return RemoteComponent_1.RemoteComponent; } });
var useDynamicScript_1 = require("./useDynamicScript");
Object.defineProperty(exports, "useDynamicScript", { enumerable: true, get: function () { return useDynamicScript_1.useDynamicScript; } });
